import { MARQUEE_WORDS } from "@/data/forge";

export default function Marquee() {
  const row = [...MARQUEE_WORDS, ...MARQUEE_WORDS];
  return (
    <section
      data-testid="marquee-section"
      className="relative py-6 border-y border-white/10 overflow-hidden"
      aria-hidden
    >
      <div className="flex w-max marquee-track">
        {row.map((word, i) => (
          <span key={`${word}-${i}`} className="flex items-center">
            <span className="headline text-3xl md:text-5xl text-white/[0.09] px-6 whitespace-nowrap">
              {word}
            </span>
            <span className="w-1.5 h-1.5 rounded-full bg-forge/40" />
          </span>
        ))}
      </div>
      <div className="pointer-events-none absolute inset-y-0 left-0 w-32 bg-gradient-to-r from-ink to-transparent" />
      <div className="pointer-events-none absolute inset-y-0 right-0 w-32 bg-gradient-to-l from-ink to-transparent" />
    </section>
  );
}
